"use client";

import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

export default function ClientSearchParamsHandler({ onMaintenanceChange }) {
    const params = useSearchParams();

    useEffect(() => {
        const maintenance = params.get("maintenance");
        if (onMaintenanceChange) {
            onMaintenanceChange(maintenance);
        }
    }, [params, onMaintenanceChange]);

    return null;
}
